import classNames from 'classnames';
import * as React from 'react';

export interface DividerProps {
  className?: string;
}
export function GizmoDivider(props: DividerProps) {
  const { className } = props;
  return (
    <span className={classNames('mx-4 h-2 border-l-2 border-FFFFFF0F rounded-lg', className)} />
  );
}
